import { ApiSchema } from "@api-types";
import { useObservable } from "@rsm";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getClientService } from "services/client.service";

export const useHomePageRedirect = (dontRedirectForTier?: ApiSchema.ClientTierLookup) => {
  const { clientId } = useParams<{ clientId?: string }>();
  useEffect(() => {
    clientId && !isNaN(Number(clientId)) && getClientService().changeClientId(Number(clientId));
  }, [clientId]);
  const defaultClientId = useObservable(getClientService().defaultClientId$);
  const currentClient = useObservable(getClientService().client$);
  const navigate = useNavigate();

  useEffect(() => {
    if (
      clientId &&
      (Number(clientId) !== defaultClientId ||
        !currentClient?.tier ||
        dontRedirectForTier === currentClient?.tier)
    ) {
      return;
    }
    if (currentClient?.tier === "Team") {
      navigate(`/${currentClient.id}/home`, { replace: true });
    } else if (currentClient) {
      navigate(`/${currentClient.id}/manage-${currentClient.tier.toLocaleLowerCase()}`, { replace: true });
    } else if (defaultClientId && !clientId) {
      navigate(`/${defaultClientId}`, { replace: true });
    }
  }, [currentClient, defaultClientId, navigate]);
};
